import { filterProperties, propertyGroup } from './review';
import type { GroupBy, HealthProperty } from './types';

export function lpcHealthLocalOptions(
  properties: HealthProperty[],
  search: string,
  groupBy: GroupBy,
  group: string,
  propertyId: string,
) {
  const searchable = filterProperties(properties, search, groupBy, '');
  return {
    groups: [
      ...new Set(
        searchable
          .filter((property) => !propertyId || property.property_id === propertyId)
          .map((property) => propertyGroup(property, groupBy)),
      ),
    ].sort(),
    properties: filterProperties(properties, search, groupBy, group),
  };
}
